/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/

// Helpers
import { getEndpoint } from '@lib/helpers'
import axios from 'axios'

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/*******************************************************************************
 * Public methods
 ******************************************************************************/

/**
 * get alerts for the authenticated user
 * @returns 
 */
export const getForUser = async (params = []) => {

    return new Promise(( resolve, reject ) => {

        axios({
            method: 'get',
            url: getEndpoint('/buyers', params),
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * create a buyer for an organisation
 * @returns 
 */
export const create = async (organisation_id, data) => {

    return new Promise(( resolve, reject ) => {

        if (!organisation_id) {
            return reject({mesage: 'organisation_id is missing'})
        }

        axios({
            method: 'post',
            url: getEndpoint('/organisation/'+organisation_id+'/buyer'),
            headers: {
                'Accept': 'application/json'
            },
            data
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * update a buyer for an organisation
 * @returns 
 */
export const updateForOrganisation = async (organisation_id, buyer_id, data) => {

    return new Promise(( resolve, reject ) => {

        if (!organisation_id) {
            return reject({mesage: 'organisation_id is missing'})
        }

        if (!buyer_id) {
            return reject({mesage: 'buyer_id is missing'})
        }

        axios({
            method: 'patch',
            url: getEndpoint('/organisation/'+organisation_id+'/buyer/'+buyer_id),
            headers: {
                'Accept': 'application/json'
            },
            data
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

export const update = async (buyer_id, data) => {

    return new Promise(( resolve, reject ) => {

        if (!buyer_id) {
            return reject({mesage: 'buyer_id is missing'})
        }

        axios({
            method: 'patch',
            url: getEndpoint('/buyers/'+buyer_id),
            headers: {
                'Accept': 'application/json'
            },
            data
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get a buyer for an organisation
 * @returns 
 */
export const showForOrganisation = async (organisation_id, buyer_id) => {

    return new Promise(( resolve, reject ) => {

        if (!organisation_id) {
            return reject({mesage: 'organisation_id is missing'})
        }

        if (!buyer_id) {
            return reject({mesage: 'buyer_id is missing'})
        }

        axios({
            method: 'get',
            url: getEndpoint('/organisation/'+organisation_id+'/buyer/'+buyer_id),
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get a buyer for an organisation
 * @returns 
 */
export const show = async buyer_id => {

    return new Promise(( resolve, reject ) => {

        if (!buyer_id) {
            return reject({mesage: 'buyer_id is missing'})
        }

        axios({
            method: 'get',
            url: getEndpoint('/buyers/'+buyer_id),
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

//'/{organisation}/buyers'
/**
 * get a buyer for an organisation
 * @returns 
 */
export const listForOrganisation = async (organisation_id, params = []) => {

    return new Promise(( resolve, reject ) => {

        if (!organisation_id) {
            return reject({mesage: 'organisation_id is missing'})
        }

        axios({
            method: 'get',
            url: getEndpoint('/organisation/'+organisation_id+'/buyers', params),
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}